import { BasePacket } from './basePacket';

export class RC900Packet extends BasePacket {
  constructor(data: any) {
    super(data);
  }
}
